(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adspoc-certificate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('adspoc-popup')) return;
    const ZOOM = 2.5;
    const mobile = () => window.matchMedia('(max-width: 767.98px)').matches;

    class AdspocPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.ac = new AbortController();
        const on = (el, ev, fn, o = {}) => el.addEventListener(ev, fn, { ...o, signal: this.ac.signal });

        on(this.dialog, 'click', (e) => {
          if (e.target.closest('[data-adspoc-close]')) return this.close();
          // click on the dark area outside the panel
          if (e.target === this.dialog) {
            const r = this.dialog.getBoundingClientRect();
            const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
            if (!inside) this.close();
          }
        });
        on(this.dialog, 'cancel', (e) => { e.preventDefault(); this.close(); });
        on(this.dialog, 'close', () => this.cleanup());
        on(window, 'popstate', () => { if (this.dialog.open && this.pushed) { this.pushed = false; this.close(true); } });

        this.querySelectorAll('[data-adspoc-zoom]').forEach((wrap) => this.setupZoom(wrap, on));
      }

      disconnectedCallback() {
        this.ac?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
      }

      open(opener) {
        if (!this.dialog || this.dialog.open) return;
        this.opener = opener || null;
        this.dialog.showModal();
        document.documentElement.classList.add('adspoc-popup-lock');
        this.dialog.querySelector('.adspoc-popup__body')?.scrollTo(0, 0);
        // Phone back button closes the popup instead of leaving the page
        if (mobile()) {
          try { history.pushState({ ...(history.state || {}), adspocPopup: true }, ''); this.pushed = true; } catch (_) {}
        }
      }

      close(fromHistory = false) {
        if (!this.dialog?.open) return;
        this.dialog.close();
        if (this.pushed && !fromHistory) {
          this.pushed = false;
          try { history.back(); } catch (_) {}
        }
      }

      cleanup() {
        if (!document.querySelector('dialog.adspoc-popup__dialog[open]')) {
          document.documentElement.classList.remove('adspoc-popup-lock');
        }
        this.querySelectorAll('[data-adspoc-zoom].is-zoomed').forEach((w) => this.unzoom(w));
        if (this.opener && document.contains(this.opener)) {
          try { this.opener.focus({ preventScroll: true }); } catch (_) {}
        }
        this.opener = null;
      }

      unzoom(wrap) {
        wrap.classList.remove('is-zoomed', 'is-dragging');
        wrap.style.height = '';
        wrap.scrollLeft = 0;
        wrap.scrollTop = 0;
        const hint = wrap.parentElement.querySelector('[data-adspoc-hint]');
        if (hint) hint.textContent = 'Tap the image to zoom';
      }

      zoomAt(wrap, clientX, clientY) {
        const r = wrap.getBoundingClientRect();
        const ox = clientX - r.left;
        const oy = clientY - r.top;
        wrap.style.height = r.height + 'px';
        wrap.classList.add('is-zoomed');
        // keep the tapped point under the finger / cursor
        wrap.scrollLeft = (ox / r.width) * r.width * ZOOM - ox;
        wrap.scrollTop = (oy / r.height) * r.height * ZOOM - oy;
        const hint = wrap.parentElement.querySelector('[data-adspoc-hint]');
        if (hint) hint.textContent = 'Drag to look around · tap again to zoom out';
      }

      setupZoom(wrap, on) {
        let down = null;
        let moved = false;
        on(wrap, 'pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = { x: e.clientX, y: e.clientY, l: wrap.scrollLeft, t: wrap.scrollTop };
          moved = false;
        });
        on(window, 'pointermove', (e) => {
          if (!down || !wrap.classList.contains('is-zoomed')) return;
          const dx = e.clientX - down.x;
          const dy = e.clientY - down.y;
          if (!moved && Math.abs(dx) + Math.abs(dy) > 5) { moved = true; wrap.classList.add('is-dragging'); }
          if (moved) { wrap.scrollLeft = down.l - dx; wrap.scrollTop = down.t - dy; }
        });
        on(window, 'pointerup', () => { down = null; wrap.classList.remove('is-dragging'); });
        on(wrap, 'click', (e) => {
          if (moved) { moved = false; return; }
          if (wrap.classList.contains('is-zoomed')) this.unzoom(wrap);
          else this.zoomAt(wrap, e.clientX, e.clientY);
        });
        on(wrap, 'keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          const r = wrap.getBoundingClientRect();
          if (wrap.classList.contains('is-zoomed')) this.unzoom(wrap);
          else this.zoomAt(wrap, r.left + r.width / 2, r.top + r.height / 2);
        });
      }
    }
    customElements.define('adspoc-popup', AdspocPopup);

    // Any [data-adspoc-open="<dialog id>"] button opens its popup — looked up inside the
    // same product form first, so quick view and the main page never cross wires.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-adspoc-open]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-adspoc-open');
      const scope = btn.closest('form, [data-quick-view-contents], .product-contents') || document;
      const dialog = scope.querySelector(`[data-adspoc-dialog="${id}"]`) || document.querySelector(`[data-adspoc-dialog="${id}"]`);
      const host = dialog?.closest('adspoc-popup');
      if (host && typeof host.open === 'function') host.open(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["adspoc-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('adspoc-size-chart')) return;
    const KEY = 'adspoc-size-unit';
    class AdspocSizeChart extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.ac = new AbortController();
        let saved = null;
        try { saved = localStorage.getItem(KEY); } catch (_) {}
        if (saved === 'in' || saved === 'cm') this.setUnit(saved, false);
        this.addEventListener('click', (e) => {
          const u = e.target.closest('[data-unit-btn]');
          if (u) return this.setUnit(u.dataset.unitBtn, true);
          const t = e.target.closest('[data-chart-tab]');
          if (t) this.show(t.dataset.chartTab, false);
        }, { signal: this.ac.signal });
        this.addEventListener('keydown', (e) => {
          const t = e.target.closest('[data-chart-tab]');
          if (!t || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
          const tabs = [...this.querySelectorAll('[data-chart-tab]')];
          const next = tabs[(tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          e.preventDefault();
          this.show(next.dataset.chartTab, true);
        }, { signal: this.ac.signal });
      }
      disconnectedCallback() { this.ac?.abort(); }
      setUnit(unit, save) {
        this.dataset.unit = unit;
        this.querySelectorAll('[data-unit-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unitBtn === unit)));
        if (save) {
          try { localStorage.setItem(KEY, unit); } catch (_) {}
          document.querySelectorAll('adspoc-size-chart').forEach((el) => { if (el !== this && el.setUnit) el.setUnit(unit, false); });
        }
      }
      show(key, focus) {
        this.querySelectorAll('[data-chart-tab]').forEach((t) => {
          const on = t.dataset.chartTab === key;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        this.querySelectorAll('[data-chart-panel]').forEach((p) => { p.hidden = p.dataset.chartPanel !== key; });
      }
    }
    customElements.define('adspoc-size-chart', AdspocSizeChart);
  })();

  (() => {
    if (customElements.get('adspoc-popup')) return;
    const ZOOM = 2.5;
    const mobile = () => window.matchMedia('(max-width: 767.98px)').matches;

    class AdspocPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.ac = new AbortController();
        const on = (el, ev, fn, o = {}) => el.addEventListener(ev, fn, { ...o, signal: this.ac.signal });

        on(this.dialog, 'click', (e) => {
          if (e.target.closest('[data-adspoc-close]')) return this.close();
          // click on the dark area outside the panel
          if (e.target === this.dialog) {
            const r = this.dialog.getBoundingClientRect();
            const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
            if (!inside) this.close();
          }
        });
        on(this.dialog, 'cancel', (e) => { e.preventDefault(); this.close(); });
        on(this.dialog, 'close', () => this.cleanup());
        on(window, 'popstate', () => { if (this.dialog.open && this.pushed) { this.pushed = false; this.close(true); } });

        this.querySelectorAll('[data-adspoc-zoom]').forEach((wrap) => this.setupZoom(wrap, on));
      }

      disconnectedCallback() {
        this.ac?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
      }

      open(opener) {
        if (!this.dialog || this.dialog.open) return;
        this.opener = opener || null;
        this.dialog.showModal();
        document.documentElement.classList.add('adspoc-popup-lock');
        this.dialog.querySelector('.adspoc-popup__body')?.scrollTo(0, 0);
        // Phone back button closes the popup instead of leaving the page
        if (mobile()) {
          try { history.pushState({ ...(history.state || {}), adspocPopup: true }, ''); this.pushed = true; } catch (_) {}
        }
      }

      close(fromHistory = false) {
        if (!this.dialog?.open) return;
        this.dialog.close();
        if (this.pushed && !fromHistory) {
          this.pushed = false;
          try { history.back(); } catch (_) {}
        }
      }

      cleanup() {
        if (!document.querySelector('dialog.adspoc-popup__dialog[open]')) {
          document.documentElement.classList.remove('adspoc-popup-lock');
        }
        this.querySelectorAll('[data-adspoc-zoom].is-zoomed').forEach((w) => this.unzoom(w));
        if (this.opener && document.contains(this.opener)) {
          try { this.opener.focus({ preventScroll: true }); } catch (_) {}
        }
        this.opener = null;
      }

      unzoom(wrap) {
        wrap.classList.remove('is-zoomed', 'is-dragging');
        wrap.style.height = '';
        wrap.scrollLeft = 0;
        wrap.scrollTop = 0;
        const hint = wrap.parentElement.querySelector('[data-adspoc-hint]');
        if (hint) hint.textContent = 'Tap the image to zoom';
      }

      zoomAt(wrap, clientX, clientY) {
        const r = wrap.getBoundingClientRect();
        const ox = clientX - r.left;
        const oy = clientY - r.top;
        wrap.style.height = r.height + 'px';
        wrap.classList.add('is-zoomed');
        // keep the tapped point under the finger / cursor
        wrap.scrollLeft = (ox / r.width) * r.width * ZOOM - ox;
        wrap.scrollTop = (oy / r.height) * r.height * ZOOM - oy;
        const hint = wrap.parentElement.querySelector('[data-adspoc-hint]');
        if (hint) hint.textContent = 'Drag to look around · tap again to zoom out';
      }

      setupZoom(wrap, on) {
        let down = null;
        let moved = false;
        on(wrap, 'pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = { x: e.clientX, y: e.clientY, l: wrap.scrollLeft, t: wrap.scrollTop };
          moved = false;
        });
        on(window, 'pointermove', (e) => {
          if (!down || !wrap.classList.contains('is-zoomed')) return;
          const dx = e.clientX - down.x;
          const dy = e.clientY - down.y;
          if (!moved && Math.abs(dx) + Math.abs(dy) > 5) { moved = true; wrap.classList.add('is-dragging'); }
          if (moved) { wrap.scrollLeft = down.l - dx; wrap.scrollTop = down.t - dy; }
        });
        on(window, 'pointerup', () => { down = null; wrap.classList.remove('is-dragging'); });
        on(wrap, 'click', (e) => {
          if (moved) { moved = false; return; }
          if (wrap.classList.contains('is-zoomed')) this.unzoom(wrap);
          else this.zoomAt(wrap, e.clientX, e.clientY);
        });
        on(wrap, 'keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          const r = wrap.getBoundingClientRect();
          if (wrap.classList.contains('is-zoomed')) this.unzoom(wrap);
          else this.zoomAt(wrap, r.left + r.width / 2, r.top + r.height / 2);
        });
      }
    }
    customElements.define('adspoc-popup', AdspocPopup);

    // Any [data-adspoc-open="<dialog id>"] button opens its popup — looked up inside the
    // same product form first, so quick view and the main page never cross wires.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-adspoc-open]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-adspoc-open');
      const scope = btn.closest('form, [data-quick-view-contents], .product-contents') || document;
      const dialog = scope.querySelector(`[data-adspoc-dialog="${id}"]`) || document.querySelector(`[data-adspoc-dialog="${id}"]`);
      const host = dialog?.closest('adspoc-popup');
      if (host && typeof host.open === 'function') host.open(btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
